import { createSelector } from 'reselect'

export const getFilteredFields = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.filter && state.vehicleParts.filter.filteredFields,
  fields => fields
)
